export default __webpack_public_path__ + "static/media/closeStream.6376917e.svg";